import React, { useState, useEffect } from "react";

import { DocumentTypes } from "../enums/DocumentTypes";
import { useMutation } from "@tanstack/react-query";
import axios from "axios";


export default function usePostAddPersonalDataDocument() {
    const post = async (data: { File: File, Comment?: string, Name, string, DocumentTypeId: DocumentTypes, Id: number }) => {
        const formData = new FormData();
        formData.append("DocumentFile", data.File);
        formData.append("Comment", data.Comment || '');
        formData.append("Title", data.Name);
        formData.append("DocumentTypeId", data.DocumentTypeId.toString());
        formData.append("DocumentId", data?.Id?.toString());

        const response = await axios.post("/DocumentApi/AddPersonalDataDocument", formData);
        return response.data;
    }

    const mutation = useMutation({
        mutationKey: ["AddPersonalDataDocument"],
        mutationFn: post,
        onSuccess: (data) => {
            console.log("%c AddPersonalDataDocument успешно:", "color: #b885f2; font-weight: bold; font-size: 16px;", data);
        },
        onError: (error) => {
            console.log("%c AddPersonalDataDocument ошибка:", "color: #f08181; font-weight: bold; font-size: 16px;", error);
        },
    });

    return {
        ...mutation,
        error: mutation.error?.response?.data?.Error || mutation.error?.message || "Неизвестная ошибка",
    };
}